import React from "react";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const toneMap = {
  blue: {
    icon: "text-sky-600 dark:text-sky-300",
    bg: "from-sky-500/15 to-blue-500/5",
  },
  emerald: {
    icon: "text-emerald-600 dark:text-emerald-300",
    bg: "from-emerald-500/15 to-lime-500/5",
  },
  violet: {
    icon: "text-violet-600 dark:text-violet-300",
    bg: "from-violet-500/15 to-fuchsia-500/5",
  },
  amber: {
    icon: "text-amber-700 dark:text-amber-300",
    bg: "from-amber-500/15 to-orange-500/5",
  },
  rose: {
    icon: "text-rose-600 dark:text-rose-300",
    bg: "from-rose-500/15 to-pink-500/5",
  },
};

const StatsCards = ({ items = [] }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
      {items.map(({ label, value, icon: Icon, tone = "blue", hint }) => {
        const t = toneMap[tone] || toneMap.blue;

        return (
          <div
            key={label}
            className="rounded-3xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950/40 p-4 shadow-sm"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-400 font-semibold">
                  {label}
                </div>
                <div className="mt-2 text-3xl font-bold text-slate-900 dark:text-white">
                  {value}
                </div>
                {hint ? (
                  <div className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                    {hint}
                  </div>
                ) : null}
              </div>

              <div
                className={cn(
                  "rounded-2xl p-3 bg-gradient-to-br",
                  t.bg
                )}
              >
                <Icon className={cn("h-5 w-5", t.icon)} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;